export const costs = [
  'Sleepless nights searching for ways to translate complex geothermal energy concepts into language your students can understand',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time",
  "Disconnected students who don't see how geothermal energy connects to their futures, careers, or real-world energy systems",
  "Awkward silences when a student asks about geothermal drilling or power generation efficiency and you don't have a clear answer",
  'Weekends lost building lesson plans, geothermal energy projects, and assessments from scratch over and over',
  'Uncertainty about how to teach geothermal geology, drilling, power generation, heating, sustainability, or advanced technologies without adequate resources',
];
